// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3M0Md","requiredAsterisk":"Info_requiredAsterisk__1Q0k6"};